import React, { useEffect, useState } from 'react';
import '../styles/header.scss';
import Hamburger from 'hamburger-react';
import logoGreen from '../assets/logo-green.svg';
import whatsappIcon from '../assets/whatsapp.svg';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const setOpen = () => setIsMenuOpen(!isMenuOpen);
  const [isScrolled, setIsScrolled] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

    // Detectar scroll
    useEffect(() => {
      const handleScroll = () => {
        setIsScrolled(window.scrollY > 0);
      };
  
      window.addEventListener('scroll', handleScroll);
  
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }, []);

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="logo">
          <a href="/">
            <img src={logoGreen} alt="Logo" />
          </a>
        </div>
        <nav className={`navLinks ${isMenuOpen ? 'active' : ''}`}>
          <div className='links'>
            <a href="/nosotros">Nosotros</a>
            <a href="/busquedas">Búsquedas</a>
            <a href="/university">University</a>
          </div>
          <div className="buttonLink mobileButtonLink">
            <a href="https://wa.me/5491155811953" className="button" target='_blank' rel="noreferrer">
              <img src={whatsappIcon} alt="WhatsApp" className="whatsappIcon" />
              Hablemos
            </a>
          </div>
        </nav>
        <div className="hamburger" onClick={toggleMenu}>
          <Hamburger 
            toggled={isMenuOpen} 
            toggle={setOpen} 
          />
        </div>
      </div>
    </header>
  );
};

export default Header;
